<template>
  <div>
    <h1>Average Days Of Stock</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :simple_date="true"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Average Days Of Stock By Location Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Average Days Of Stock By Location</h5>
      <average-days-of-stock-by-location
        :filterUrl="filterUrl"
      ></average-days-of-stock-by-location>
    </div>
    <!-- Average Days Of Stock By Location End -->

    <!-- Average Days Of Stock By Category And Segment Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Average Days Of Stock By Category And Segment</h5>
      <average-days-of-stock-by-category-and-segment
        :filterUrl="filterUrl"
        @getSegment="setSubSeriesTypeFilter"
      ></average-days-of-stock-by-category-and-segment>
    </div>
    <!-- Average Days Of Stock By Category And Segment End -->

    <!-- Average Days Of Stock By Sub Series And Type Start -->
    <div class="innerBox mt-5" v-if="shown.subSeriesType">
      <h5 class="mb-2">Average Days Of Stock By Sub-Series And Type</h5>
      <average-days-of-stock-by-sub-series-and-type
        :filterUrl="subSeriesTypeFilterUrl"
        @getCodeMarket="setCodeMarketFilter"
      ></average-days-of-stock-by-sub-series-and-type>
    </div>
    <!-- Average Days Of Stock By Sub Series And Type End -->

    <!-- Average Days Of Stock By Code Market Start -->
    <div class="innerBox mt-5" v-if="shown.codeMarket">
      <h5 class="mb-2">Average Days Of Stock By Code (Market Name)</h5>
      <average-days-of-stock-by-code-market
        :filterUrl="codeMarketFilterUrl"
      ></average-days-of-stock-by-code-market>
    </div>
    <!-- Average Days Of Stock By Code Market End -->
  </div>
</template>

<script>
  import qs from 'qs'

  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import averageDaysOfStockByLocation from './children/averageDaysOfStockByLocation'
  import averageDaysOfStockByCategoryAndSegment from './children/averageDaysOfStockByCategoryAndSegment'
  import averageDaysOfStockBySubSeriesAndType from './children/averageDaysOfStockBySubSeriesAndType'
  import averageDaysOfStockByCodeMarket from './children/averageDaysOfStockByCodeMarket'

  export default {
    data () {
      return {
        filterUrl : '',
        subSeriesTypeFilterUrl : '',
        codeMarketFilterUrl : '',
        
        shown : {
          subSeriesType : false,
          codeMarket : false,
        },

        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      averageDaysOfStockByLocation,
      averageDaysOfStockByCategoryAndSegment,
      averageDaysOfStockBySubSeriesAndType,
      averageDaysOfStockByCodeMarket,
    },
    mounted () {
      this.fetchFilter++;
    },
    watch : {
      'filterUrl' : function(){
        this.subSeriesTypeFilterUrl = this.filterUrl;

        this.shown.subSeriesType = false;
        this.shown.codeMarket = false;
      }
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      },
      setSubSeriesTypeFilter(value){
        //load and create chart first (no data yet)
        this.shown.subSeriesType = true;

        var finalFilterUrl = this.filterUrl
        if(this.filterUrl.includes('segment')){
          let obj = qs.parse(this.filterUrl)
          obj['segment'] = `${obj['segment']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.filterUrl}&segment=${value}`
        }
        setTimeout(()=>{
          this.subSeriesTypeFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      },
      setCodeMarketFilter(value){
        //load and create chart first (no data yet)
        this.shown.codeMarket = true;

        var finalFilterUrl = this.subSeriesTypeFilterUrl
        if(this.filterUrl.includes('type')){
          let obj = qs.parse(this.subSeriesTypeFilterUrl)
          obj['type'] = `${obj['type']},${value}`

          finalFilterUrl = qs.stringify(obj)
          finalFilterUrl = finalFilterUrl.replace(/%2C/g, ',')
        } else {
          finalFilterUrl = `${this.subSeriesTypeFilterUrl}&type=${value}`
        }
        setTimeout(()=>{
          this.codeMarketFilterUrl = finalFilterUrl
          window.scrollTo(0, document.body.scrollHeight);
        }, 200)
      }
    }
  }
</script>

<style scoped>
  
</style>